import React, { useState, useEffect } from "react";
import get from "lodash/get";
import { Link } from "@quintype/components";
import { useSelector, useDispatch } from "react-redux";
import throttle from "lodash/throttle";

import { MenuItem } from "../../menu-item";
import MenuRight from "../../../atoms/icons/menu-right";

import { OPEN_SEARCHBAR, OPEN_HAMBURGER_MENU } from "../../../store/actions";
import Logo from "../../../atoms/icons/logo";
import HamburgerMenu from "../../../atoms/hamburger-menu";
import LatestButton from "../../../atoms/latest-button";
import EPaperButton from "../../../atoms/e-paper-button";
import SearchBox from "../../../atoms/search-box";
import HamburgerMenus from "../hamburger-menus";

import StickyNavbar from "../../../molecules/sticky-navbar";

import "./mobile-header.m.css";
import JoinDHChannel from "../../../atoms/join-dh-channel";

const MobileHeader = () => {
  const [isActive, setisActive] = useState(false);
  const dispatch = useDispatch();

  const getState = useSelector((state) => state);

  const primaryMenus = get(getState, ["qt", "data", "navigationMenu", "primaryMenus"], []);
  const secondaryMenus = get(getState, ["qt", "data", "navigationMenu", "secondaryMenus"], []);
  const isHamburgerMenuOpen = get(getState, ["isHamburgerMenuOpen"], false);

  const toggleHandler = () => {
    dispatch({
      type: OPEN_HAMBURGER_MENU,
      isHamburgerMenuOpen: !isHamburgerMenuOpen
    });
    dispatch({
      type: OPEN_SEARCHBAR,
      isSearchBarOpen: false
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", throttle(getScroll, 250));
    return () => {
      window.removeEventListener("scroll", throttle(getScroll, 250));
    };
  }, []);

  const getScroll = () => {
    if (typeof window !== "undefined") {
      if (window.scrollY > 60) {
        setisActive(true);
      }
      if (window.scrollY < 50) {
        setisActive(false);
      }
    }
  };

  const getPrimaryMenus = () => {
    return (
      <div styleName="primary-menus">
        {primaryMenus.slice(0, 10).map((item, index) => (
          <div key={index} styleName="primary-menu-item">
            <MenuItem
              changeTextColor={item?.data?.color.toLowerCase() !== "#ffffff"}
              changeTextWeight={item?.data?.color.toLowerCase() !== "#ffffff"}
              item={item}
              menuStyle="menu-link"
              toggleHandler={() =>
                dispatch({
                  type: OPEN_SEARCHBAR,
                  isSearchBarOpen: false
                })
              }
            />
          </div>
        ))}
      </div>
    );
  };

  return (
    <>
      <div styleName="header">
        <div styleName="primary">
          <div>
            <Link href="/">
              <Logo height="40" width="auto" />
            </Link>
          </div>

          <div styleName="button-wrapper">
            {/* <LatestButton /> */}
            <div styleName="btn">
              <JoinDHChannel />
            </div>
            <div styleName="btn">
              <EPaperButton />
            </div>
            <SearchBox height="18px" width="18px" />
          </div>
        </div>

        <div styleName="secondary">
          <div>
            <HamburgerMenu
              isMobileHamburger={false}
              onMenuToggle={() => toggleHandler()}
              isMegaMenuOpen={isHamburgerMenuOpen}
            />
          </div>
          <div>{getPrimaryMenus()}</div>
        </div>
        <div className={isActive && "hide-mobile"} styleName="menu-wrapper secondary-menu-wrapper">
          {secondaryMenus.slice(0, 10).map((item, index) => (
            <React.Fragment key={index}>
              <div styleName="secondary-menu-item">
                <MenuRight />
                <MenuItem
                  item={item}
                  key={index}
                  menuStyle="menu-link"
                  changeTextColor={item?.data?.color.toLowerCase() !== "#ffffff"}
                  changeTextWeight={item?.data?.color.toLowerCase() !== "#ffffff"}
                />
              </div>
            </React.Fragment>
          ))}
        </div>
      </div>
      <HamburgerMenus />
      <StickyNavbar onMenuToggle={() => toggleHandler()} />
    </>
  );
};

export default MobileHeader;
